import React, { useState } from 'react';
import { Copy, Loader2, Printer, QrCode, X } from 'lucide-react';
import { api, useAuth } from '../../context/AuthContext';

const iban4 = (s) => s.replace(/(.{4})/g, '$1 ').trim();
const eur = (v) => Number(v || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

const Zeile = ({ label, wert, testId }) => (
  <div className="flex items-center gap-2 text-xs">
    <span className="w-28 text-gray-500 shrink-0">{label}</span>
    <span className="flex-1 font-mono text-[#1B3A5C] break-all" data-testid={testId}>{wert}</span>
    <button type="button" onClick={() => navigator.clipboard?.writeText(wert.replace(/ /g, label === 'IBAN' ? '' : ' '))} className="p-1 text-[#7a8a99] hover:text-[#b8893d]" title="Kopieren"><Copy className="w-3.5 h-3.5" /></button>
  </div>
);

export const UeberweisungQr = ({ r }) => {
  const { portalansicht } = useAuth();
  const [d, setD] = useState(null);
  const [offen, setOffen] = useState(false);
  const [fehler, setFehler] = useState('');
  const umschalten = () => {
    setOffen((o) => !o);
    if (!d) api.get(`/rechnungen/${r.id}/ueberweisung`).then((x) => setD(x.data)).catch((e) => setFehler(e?.response?.data?.detail || 'QR-Code nicht verfügbar'));
  };
  return (
    <>
      <button type="button" onClick={umschalten} className="inline-flex items-center gap-1.5 text-xs px-3 py-2 rounded-[10px] border border-[#b8893d] text-[#1B3A5C] hover:bg-[#fbf7f0]" data-testid={`portal-rechnung-qr-${r.id}`}>
        {offen ? <X className="w-3.5 h-3.5" /> : <QrCode className="w-3.5 h-3.5" />}Überweisen
      </button>
      {offen && (
        <div className="basis-full mt-2 p-4 rounded-2xl bg-[#f8fafc] border border-gray-200 flex flex-wrap gap-5 items-center" data-testid={`portal-rechnung-qr-panel-${r.id}`}>
          {!d && !fehler && <Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" />}
          {fehler && <p className="text-xs text-rose-700">{fehler}</p>}
          {d && <>
            <img src={d.qr_png} alt={`Überweisungs-QR-Code für Rechnung ${r.nummer}`} className="w-40 h-40 rounded-lg bg-white p-1 border border-gray-200" data-testid={`portal-rechnung-qr-bild-${r.id}`} />
            <div className="flex-1 min-w-[240px] space-y-1.5">
              <p className="text-sm text-[#1B3A5C] font-medium">Mit der Banking-App scannen</p>
              <p className="text-xs text-gray-500 mb-2">Empfänger, IBAN, Betrag und Verwendungszweck werden automatisch übernommen (GiroCode).</p>
              <Zeile label="Empfänger" wert={d.inhaber} />
              <Zeile label="IBAN" wert={iban4(d.iban)} testId={`portal-rechnung-iban-${r.id}`} />
              {d.bic && <Zeile label="BIC" wert={d.bic} />}
              <Zeile label="Betrag" wert={eur(d.betrag)} />
              <Zeile label="Verwendungszweck" wert={d.zweck} testId={`portal-rechnung-zweck-${r.id}`} />
              <a href={`${process.env.REACT_APP_BACKEND_URL}/api/${portalansicht ? 'kanzlei/' : ''}rechnungen/${r.id}/zahlseite.pdf`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 mt-2 text-xs px-3 py-2 rounded-[10px] border border-gray-300 bg-white text-[#1B3A5C] hover:border-[#b8893d]" data-testid={`portal-rechnung-zahlseite-${r.id}`}><Printer className="w-3.5 h-3.5" />Zahlseite drucken (PDF)</a>
            </div>
          </>}
        </div>
      )}
    </>
  );
};
